import {
  Sheet,
  SheetBody,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@suraasa/placebo-ui"

type Props = {
  open: boolean
  handleClose: () => void
}
const InterviewQuestionsKit = ({ open, handleClose }: Props) => {
  return (
    <Sheet open={open} onOpenChange={handleClose}>
      <SheetContent height={98} closeWhenInteractOutside>
        <SheetHeader>
          <SheetTitle>Interview Questions Kit</SheetTitle>
        </SheetHeader>
        <SheetBody className="flex grow flex-col">
          <iframe
            width="100%"
            height="100%"
            title="Interview Questions Kit"
            src="https://assets.suraasa.com/lms/profile-assets/interview-questions-kit.html"
          />
        </SheetBody>
      </SheetContent>
    </Sheet>
  )
}

export default InterviewQuestionsKit
